module.exports = __webpack_public_path__ + "03.png?bfbd88c5243442fb407c9ce2b386c6d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/03.png
// module id = 118
// module chunks = 3